import React from 'react'
import "./Footer.css"

export default function Footer() {
  return (
    <div className='footer__container'>
      <div className='footer__text'>
        <h4> Robert Balonek | Copywright © 2022 | All Rights Reserved</h4>
        <h4> Privacy Policy - Terms & Conditions - Disclaimer</h4>
      </div>
    </div>
  )
}
